import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-migrate-heroku',
  imports: [RouterLink, MatButtonModule, MatIconModule],
  templateUrl: './heroku.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../migrate.shared.css', './heroku.component.css'],
})
export class MigrateHerokuComponent {}
